import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState<string | null>(null);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const menuItems = [
    { label: '首頁', path: '/' },
    {
      label: '女童',
      path: '/collections/girls',
      submenu: [
        { label: '女童上衣', path: '/collections/girls-tops-bottoms' },
        { label: '女童褲裙', path: '/collections/girls-tops-bottoms' },
        { label: '女童外套', path: '/collections/girls-outerwear' },
        { label: '女童連衣裙', path: '/collections/girls-dresses' },
        { label: '女童套裝', path: '/collections/girls-sets' },
      ],
    },
    {
      label: '男童',
      path: '/collections/boys',
      submenu: [
        { label: '男童上衣', path: '/collections/boys-tops-bottoms' },
        { label: '男童褲子', path: '/collections/boys-tops-bottoms' },
        { label: '男童外套', path: '/collections/boys-outerwear' },
        { label: '男童全部', path: '/collections/boys-all' },
      ],
    },
    { label: '大童', path: '/collections/big-kids' },
    { label: 'BABY', path: '/collections/baby' },
    { label: '家居服', path: '/collections/homewear' },
    { label: '童裝鞋', path: '/collections/shoes' },
    { label: '兒童用品', path: '/collections/kids-items' },
    { label: '童裝資訊', path: '/blogs' },
    { label: '聯絡我們', path: '/contact' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      {/* 主導航 */}
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex-shrink-0 flex items-center gap-2">
            <img
              src="https://static.readdy.ai/image/db57219f15db34a21692ac78f577b434/b1c831aa8b093cf251e352a6a4bdb7f5.jpeg"
              alt="Lam Lam Wholesale Company"
              className="h-14 w-auto object-contain"
            />
          </Link>

          {/* 桌面導航 */}
          <nav className="hidden lg:flex items-center space-x-1">
            {menuItems.map((item) => (
              <div
                key={item.label}
                className="relative group"
                onMouseEnter={() => item.submenu && setOpenDropdown(item.label)}
                onMouseLeave={() => setOpenDropdown(null)}
              >
                <Link
                  to={item.path}
                  className="px-3 py-2 text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors whitespace-nowrap cursor-pointer flex items-center"
                >
                  {item.label}
                  {item.submenu && (
                    <i className="ri-arrow-down-s-line ml-1 text-xs"></i>
                  )}
                </Link>
                {item.submenu && openDropdown === item.label && (
                  <div className="absolute left-0 top-full mt-0 w-48 bg-white shadow-lg rounded-md py-2 z-50">
                    {item.submenu.map((subItem) => (
                      <Link
                        key={subItem.label}
                        to={subItem.path}
                        className="block px-4 py-2 text-sm text-gray-700 hover:bg-amber-50 hover:text-amber-600 transition-colors cursor-pointer"
                        onClick={() => setOpenDropdown(null)}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>

          {/* 右側圖標 */}
          <div className="flex items-center space-x-4">
            <button className="p-2 text-gray-700 hover:text-amber-600 transition-colors cursor-pointer" aria-label="搜索">
              <i className="ri-search-line text-xl"></i>
            </button>
            <button className="p-2 text-gray-700 hover:text-amber-600 transition-colors cursor-pointer" aria-label="帳戶">
              <i className="ri-user-line text-xl"></i>
            </button>

            {/* 移動端菜單按鈕 */}
            <button
              className="lg:hidden p-2 text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              aria-label="菜單"
            >
              <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-2xl`}></i>
            </button>
          </div>
        </div>
      </div>

      {/* 移動端菜單 */}
      {isMobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 max-h-[calc(100vh-140px)] overflow-y-auto">
          <nav className="px-4 py-4 space-y-2">
            {menuItems.map((item) => (
              <div key={item.label}>
                <Link
                  to={item.path}
                  className="block py-2 text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer"
                  onClick={() => !item.submenu && setIsMobileMenuOpen(false)}
                >
                  {item.label}
                </Link>
                {item.submenu && (
                  <div className="pl-4 space-y-1 mt-1">
                    {item.submenu.map((subItem) => (
                      <Link
                        key={subItem.label}
                        to={subItem.path}
                        className="block py-1.5 text-sm text-gray-600 hover:text-amber-600 transition-colors cursor-pointer"
                        onClick={() => setIsMobileMenuOpen(false)}
                      >
                        {subItem.label}
                      </Link>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
